import { createSvgIcon } from '@mui/material/utils'

export const CheckBroken = createSvgIcon(
  <svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M17.5 10.5C17.5 14.6421 14.1421 18 10 18C5.85786 18 2.5 14.6421 2.5 10.5C2.5 6.35786 5.85786 3 10 3C11.1767 3 12.2901 3.27099 13.2812 3.75397M16.0938 5.8125L9.53125 12.375L7.65625 10.5' stroke='#29BF7D' stroke-width='1.66667' stroke-linecap='round' stroke-linejoin='round' />
  </svg>
)
